import { Plus, Star } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { Textarea } from "../../../components/ui/textarea";
import { Label } from "../../../components/ui/label";

const uid = () => (crypto.randomUUID ? crypto.randomUUID() : `id-${Date.now()}`);

export default function ReviewsTab({ content, patchItem, removeItem, patchList, Card }) {
  return (
    <>
      <p className="text-sm text-stone-500">These quotes scroll across the Happy Tails section of the site.</p>
      <div className="mt-6 grid gap-5 lg:grid-cols-2">
        {content.testimonials.map((t, i) => (
          <Card key={t.id} testid={`review-editor-${i}`} onDelete={() => removeItem("testimonials", t.id)}>
            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <Label>Customer name</Label>
                <Input className="mt-1.5" value={t.name} onChange={(e) => patchItem("testimonials", t.id, { name: e.target.value })} data-testid={`review-name-input-${i}`} placeholder="Michelle R." />
              </div>
              <div>
                <Label>Dog's name</Label>
                <Input className="mt-1.5" value={t.dogName} onChange={(e) => patchItem("testimonials", t.id, { dogName: e.target.value })} data-testid={`review-dog-input-${i}`} placeholder="Bella" />
              </div>
            </div>
            <div className="mt-4">
              <Label>Quote</Label>
              <Textarea className="mt-1.5" rows={3} value={t.quote} onChange={(e) => patchItem("testimonials", t.id, { quote: e.target.value })} data-testid={`review-quote-input-${i}`} />
            </div>
            <label className="mt-4 flex items-center gap-2 text-sm text-stone-600">
              <Star size={14} className="text-lavender-500" />
              Stars
              <Input
                type="number" min={1} max={5}
                className="w-20"
                value={t.stars}
                onChange={(e) => patchItem("testimonials", t.id, { stars: Math.max(1, Math.min(5, Number(e.target.value) || 5)) })}
                data-testid={`review-stars-input-${i}`}
              />
            </label>
          </Card>
        ))}
      </div>
      <button
        onClick={() => patchList("testimonials", [...content.testimonials, { id: uid(), name: "", dogName: "", quote: "", stars: 5 }])}
        data-testid="add-review-button"
        className="mt-6 inline-flex items-center gap-2 rounded-full border-2 border-dashed border-lavender-300 px-6 py-3 text-sm font-semibold text-lavender-700 transition-colors hover:border-lavender-500 hover:bg-lavender-100"
      >
        <Plus size={16} /> Add review
      </button>
    </>
  );
}
